import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { useAccountStatus } from '../features/auth/hooks/useAccountStatus';

/**
 * Banner shown to users with pending or suspended account registration
 * Displayed at the top of the app when accountStatus is 'pending' or 'suspended'
 */
export function PendingRegistrationBanner() {
  const { isPending, isSuspended, registrationMethod, loading } = useAccountStatus();

  if (loading || (!isPending && !isSuspended)) {
    return null;
  }

  const getMessage = () => {
    if (isSuspended) {
      return 'Your account has been suspended. You cannot access most features. Please contact support for more information.';
    }

    if (registrationMethod === 'approval') {
      return 'Your registration request is pending approval. You can browse groups and events, but you cannot join groups or create content until your account is approved. You will receive an email notification once your request has been reviewed.';
    }
    if (registrationMethod === 'invite') {
      return 'Your account setup is pending. Please check your email for the invite code or contact an administrator.';
    }
    return 'Your account registration is pending. Some features are limited until your account is fully activated.';
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Alert
        severity={isSuspended ? 'error' : 'warning'}
        sx={{
          borderRadius: 0,
          '& .MuiAlert-message': {
            width: '100%'
          }
        }}
      >
        <AlertTitle>{isSuspended ? 'Account Suspended' : 'Account Pending Approval'}</AlertTitle>
        <Typography variant="body2">
          {getMessage()}
        </Typography>
      </Alert>
    </Box>
  );
}
